import { AllLanguageType } from '../types/StoreTypes';

// 위글루(zepetoful) 엔트리 상수는 전부 소멸 — 랜딩 7종·프라이싱·스토어 5종은
// zep-cms(consts/cmsConsts.ts), 둘러보기 에듀는 consts/explore-edu/*.json 내장.
// /trouble/[id] 도 zep-cms 로 옮겼다(consts/troubleContents.ts).

export const StoreLocales: AllLanguageType[] = [
  'en',
  'ko',
  'ja',
  'id',
  'th',
  'vi',
  'es',
  'pt',
  'ge',
  'fr',
  'ru',
];

// 서버에서 사용하는 에러코드 모음, 찾기 쉽게 하기 위해 변수명은 v1과 통일
export enum ErrorStatus {
  FAILED = -1,
  IS_NOT_IMAGE_FILE = -84,
  TOO_MANY_SIGNIN_TRIAL = -94,
  CACHE_INVALIDATION_FAILED = -103,
  NOT_UPLOAD_PREMIUM_SPACE_MAP_ASSET = -116,
  NOT_UPLOAD_INVISIBLE_MAP_ASSET = -117,
  NOT_UPLOAD_REVIEW_COMPLETED_APP_ASSET = -120,
  NOT_UPLOAD_REVIEW_COMPLETED_MAP_ASSET = -121,
  FINISHED_PAYMENT = -124,
  DISABLED_PAYMENT = -125,
  NOT_AGREED_TERMS_OR_PRIVACY_POLICY = -192,
  TOO_MANY_AUTH_CODE_FAILURES = -194, // 인증번호 5회 이상 입력 실패
}

// 플로팅 위젯(헬프센터·CRM 공지) 공통 차단 경로. startsWith 로 매칭한다.
// 아래 세 인증 경로는 마운트 직후 곧바로 다른 문서/라우트로 이탈하는 리다이렉트
// 전용 페이지라, 위젯이 띄워질 수도 없는데 조회 요청만 나가고 그 요청이 이탈에
// 잘려 "TypeError: Failed to fetch"(Safari 는 "Load failed") 로 보고됐다.
//   /accounts/signin        → window.location.replace(auth-app)
//   /accounts/signin-finish → router.replace('/home/spaces')
//   /auth/sso-exchange-token→ router.replace(callbackUrl)
// (/accounts/signin 은 startsWith 라 signin-finish 도 함께 덮는다.)
export const CHANNEL_TALK_UNUSED_PATHS = [
  '/store',
  '/home/create',
  '/accounts/agree-terms',
  '/accounts/signin',
  '/auth/sso-exchange-token',
  '/shared',
];
